<template>
    <div>

        <splide
            ref="splide1"
            :options="splide_options"
        >
            <splide-slide
                class="tw-pt-6 tw-pr-4 tw-border-r tw-border-dark-grey last-of-type:tw-border-r-0 carousel-slide"
                v-for="(item, index) in items"
                :key="index">

                <h3>{{ item.title }}</h3>
                <img
                    class="carousel-image"
                    :src="'/storage/history/'+ item.image_desktop"
                    :alt="item.image_caption"
                />
                <div class="tw-py-4 p-medium">{{ item.body }}</div>

                <div
                    v-if="!!item.url"
                >
                    <a :href="item.url" class="text-link tw-text-xs tw-underline tw-mr-0 md:tw-mr-20">
                        Read More
                    </a>
                </div>

            </splide-slide>
        </splide>
    </div>
</template>

<script>
import SolidGreenArrows from '@/Generic/icons/SolidGreenArrows'

export default {
    components: {
        SolidGreenArrows,
    },
    name: 'HistoryCarousel',
    props: {
        items: {
            type: Array,
            required: false,
            default: function () {
                return undefined
            }
        },
    },
    data() {
        return {
        }
    },
    computed: {
        num_slides_per_page() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return 1
                case 'sm': return 1
                case 'md': return 2
                case 'lg': return 4
                case 'xl': return 4
            }
        },
        splide_options () {
            return {
                type: 'slide',
                gap: '1em',
                autoplay: false,
                pauseOnHover: true,
                resetProgress: true,
                perPage: this.num_slides_per_page,
                perMove: 1,
                navigation: false,
                pagination: false,
                arrows: false,
                wheel: true,
            }
        },
    },
    created() {
        import('@splidejs/splide/dist/css/splide.min.css')
    },
    mounted() {
        //
    },
    methods: {
        changeSrc(src) {
            this.currentSrc = src
        },
        goPrev() {
            this.$refs.splide1.go('-1')
        },
        goNext() {
            this.$refs.splide1.go('+1')
        },
        displayYear(item) {
            let has_month = !!item.month
            let month_prefix = (has_month && item.month < 10) ? '0' : ''
            let month_suffix = !has_month ? '' : `-${month_prefix}${item.month}`
            return `${item.year}${month_suffix}`
        }
    }
};
</script>
<style scoped>
.carousel-slide {
    width: 250px;
}
.carousel-image {
    width: auto;
    height: auto;
    object-fit: cover;
}
.websites-section a {
    width: fit-content;
    font-size: 33px;
    font-weight: 300;
}
</style>
